module.exports = __webpack_public_path__ + "static/media/passenger.2fe28570.png";